import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/app/statistics")({
  component: StatisticsRedirectPage,
});

function StatisticsRedirectPage() {
  return (
    <Navigate
      to="/app/vocabulary_progress"
      search={{ tab: undefined }}
      replace
    />
  );
}
